export default __webpack_public_path__ + "static/media/rentalVehicle.96ac7e64.svg";